// Run this example by adding <%= javascript_pack_tag 'hello_erb' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. Don't forget to uncomment erb tag after adding it to your layout file.



import "/tmp/build_7f195a15/vendor/bundle/ruby/3.3.0/gems/social-share-button-1.2.4/app/assets/javascripts/social-share-button.coffee"